module.exports = __webpack_public_path__ + "media/gallery/photo06-72282d71.webp";